export default __webpack_public_path__ + "static/media/allstatuses.c6142b81.svg";